// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1T83_","controls":"Table_controls__2O57M","filter":"Table_filter__PrHMO","search":"Table_search__33TPH","tableEntries":"Table_tableEntries__3Q9_n"};